import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { jwtDecode } from "jwt-decode";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";
import { maintenance } from "src/app/support/maintenance";

@Injectable()
export class ProvideMemberDisabledGuard {
  constructor(
    private readonly router: Router,
    private readonly bootstrapService: BootstrapService
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const currentMemberAuth = this.bootstrapService.getCurrentMemberAuth();
      if (!currentMemberAuth) {
        failure(this.router);
        return false;
      }

      const decodedJwt = jwtDecode<{ disabled: boolean }>(
        currentMemberAuth.token
      );
      if (decodedJwt.disabled) {
        failure(this.router);
        return false;
      }
      return true;
    } catch (ex) {
      failure(this.router);
      return false;
    }
  }
}

function failure(router: Router): boolean {
  maintenance(router, { code: ErrorCodes.ERR_007 });

  return false;
}
